import { createFileRoute, redirect } from "@tanstack/react-router";
import { isLoggedIn } from "@/hooks/useAuth";
import { AdminDashboardLayout } from "@/layouts/AdminDashboardLayout";
import { checkIsSuperuser, getRedirectPath } from "@/lib/utils";

export const Route = createFileRoute("/_superuser")({
  beforeLoad: async () => {
    if (!isLoggedIn()) {
      throw redirect({ to: "/login" });
    }
    const isSuperuser = checkIsSuperuser();
    if (!isSuperuser) {
      throw redirect({ to: getRedirectPath() });
    }
  },
  component: AdminDashboardLayout,
});
